import styled from 'styled-components';

export const InfoWrapperStyled = styled.div`
  margin-bottom: 8rem;
`;

export const ButtonWrapperStyled = styled.div`
  margin-bottom: 2rem;
`;
